import { useState } from "react";
import { applyTheme, getTheme, type Theme } from "../lib/theme.ts";

/** A small light/dark toggle button (persists the choice). */
export default function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(getTheme());
  const flip = () => {
    const next: Theme = theme === "dark" ? "light" : "dark";
    applyTheme(next);
    setTheme(next);
  };
  return (
    <button onClick={flip} title="Toggle light / dark" style={{ fontSize: "0.85rem", padding: "2px 10px", borderRadius: 6, border: "1px solid var(--border)", background: "var(--card)", color: "var(--fg)", cursor: "pointer" }}>
      {theme === "dark" ? "☀ Light" : "🌙 Dark"}
    </button>
  );
}
